import React from 'react';
import { Merchandiser } from '../../redux/composableDevice/model/Merchandiser.model';
import { Grid } from '@mui/material';
import { DeviceDetail } from './Components/DeviceDetail';
import { DeviceControlUnitOverview } from './Components/DeviceControlUnitOverview';

export const MerchandiserStandardView = (props: {
  merchandiser: Merchandiser;
}) => {
  const { merchandiser } = props;
  return (
    <Grid container spacing={1}>
      <Grid item xs={12} sm={4}>
        <DeviceDetail merchandiser={merchandiser} />
      </Grid>
      <Grid item xs={12} sm={8}>
        <DeviceControlUnitOverview merchandiser={merchandiser} />
      </Grid>
    </Grid>
  );
};
